(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then((response) => response.text()).then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    }).catch((e) => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-list-collections"]) return;
  try {
    
  (function() {
    var scrollApp = {
      init: function() {
        this.bindEvents();
        this.toggleScroll();
      },

      bindEvents: function() {
        $(window).scroll(this.toggleScroll);
        $('.collection-nav > a').click(this.smoothScroll);
      },

      toggleScroll: function() {
        var scrollBarLocation = $(this).scrollTop();
        $('.collection-nav > a').each(function() {
          var sectionOffset = $(this.hash).offset().top - 200;
          if (Math.floor(sectionOffset) <= scrollBarLocation) {
            $(this).addClass('!border-primary');
            $(this).removeClass('border-[#d05a2e]');
            $(this).siblings().removeClass('!border-primary');
          } else {
            $(this).removeClass('!border-primary');
          }
        });
      },

      smoothScroll: function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(this.hash).offset().top - 200
        }, 800);
      }
    }

    scrollApp.init()
  })();

  } catch(e) { console.error(e); }
})();
})();
